<!-- 作品管理 -->
<template>
  <div class="program-management">
    <cs-form label-width="90px" class="header-search-box padding-t-20" ref="validForm"
      form-width="100%"
      :form="searchParams"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true">
      <template slot="search">
        <el-button type="primary" @click="search">查 询</el-button>
        <!-- <el-button size="small" @click="resetHandle('validForm')">重置</el-button> -->
      </template>
    </cs-form>
    <div class="padding-b-20">
      <el-button @click="goUploadVideo" type="primary">
        <i class="icon-shangchuanziyuan"></i>
        视频上传
      </el-button>
      <el-button type="primary"  @click="batchJoinAlbum">
         <i class="icon-tianjia"></i>
        批量加入专辑
      </el-button>
      <el-button @click="goBatchImport()" type="primary" v-if="!perTree.isOpen || perTree['workManagement:historySync']">
       <i class="icon-daoru"></i>
        历史数据同步
      </el-button>
    </div>
    <cs-table ref="multipleTable" :tableCols="tableCols" :tableData="tableData"
      class="no-shadow-table"
      :paginationOption="paginationOption"
      :show-header="false"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      @selection-change="selectionChange"
      :show-overflow-tooltip="false"
      >
      <template slot-scope="scope" slot="imgUrl">
        <program-list type="0" project="ugc" :data="scope.row">
          <template slot="state-slot">
            <el-tag class="publish-state" v-if="scope.row.pushFlag == -1" type="info">{{'未发布'}}</el-tag>
            <el-tag class="publish-state" v-else-if="scope.row.auditState == 'AUDIT_NO_PASS' || scope.row.auditState == 'UNIFORM_AUDIT_NO_PASS'" type="danger" @click="checkReson(scope.row)">{{'未通过'}}</el-tag>
            <el-tag class="publish-state" v-else-if="scope.row.auditState == 'AUDIT_PASS' ||scope.row.auditState == 'UNIFORM_AUDIT_PASS' " type="success">{{'已通过'}}</el-tag>
            <el-tag class="publish-state" v-else-if="scope.row.auditState == 'AUDIT_ING'" type="warning">{{'审核中'}}</el-tag>
          </template>
          <tags-list v-if="scope.row.tagsList" :data="scope.row.tagsList" slot="title-slot"/>

          <!--<div slot="audit-slot" class="auditStyle">
             <span>审核状态： <span :class="scope.row.auditState|auditStyle">{{scope.row.auditState|auditState}}</span> </span>
             <span v-if="scope.row.auditState =='AUDIT_NO_PASS'||scope.row.auditState =='RE_AUDIT_NO_PASS' || scope.row.auditState =='UNIFORM_AUDIT_NO_PASS'"
              class="reson" @click="checkReson(scope.row.reason)">查看原因
            </span>
          </div>-->
        </program-list>
      </template>
    </cs-table>
    <inside-dialog ref="detailDialog" :insideData="dialogData" groupIn="program" :imgUrl="imgUrl" :goEdit="true" @goEditPage="goEdit"/>
    <!-- 数据趋势图 -->
    <DoubleLineDialog ref="DoubleLineDialog" :dialogData='dialogData'  :programs="false"/>
    <BatchImport ref="batchImportDataDialog"/>
  </div>
</template>
<script>
import { addData } from '@/resource/api/data.js'
import { fetchPrograms, checkReason, fetchProgramsDelete, fetchDictionarys } from '@/resource/api/index'
import ProgramList from '@/components/ProgramList'
import TagsList from '@/components/TagsList'
import InsideDialog from '@/views/common/dialog/program-group-detail.vue'
import DoubleLineDialog from '@/views/common/dialog/program-group-doubleLine.vue'// 播放统计dialog
import BatchImport from '@/views/common/dialog/batch-import-catalogue.vue'

export default {
  components: {
    ProgramList,
    TagsList,
    InsideDialog, // 编目详情
    BatchImport,
    DoubleLineDialog
  },
  props: ['perTree'],
  data () {
    return {
      isShow: false,
      imgUrl: '',
      categoryList: [],
      searchParams: {
        category: '',
        limit: 20,
        offset: 1,
        operator: '',
        name: '',
        auditState: ''
      },
      tagsList: [],
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [
        { props: '', type: 'selection' },
        { prop: 'imgUrl', label: '封面图', type: 'slot', align: 'left' },
        {
          prop: 'control',
          type: 'spbtn',
          label: '操作',
          width: 150,
          groups: [
            {
              isShow: () => true,
              title: '详情',
              clickHandler: this.goDetailInfo
            },
            {
              isShow: (row) => row.pushFlag == -1 || row.auditState == 'AUDIT_NO_PASS',
              title: '删除',
              clickHandler: this.del
            }
          ]
        }
      ],
      tableData: [],
      paginationOption: {},
      dialogData: {},
      multipleSelection: []
    }
  },
  created () {
    this.searchParams.operator = this.$store.state.router.createBy
    this.paginationOption['page-size'] = this.$store.state.pageLimit
    this.searchParams.limit = this.$store.state.pageLimit
    this.categoryList = addData.categoryList
    this.getData(this.searchParams)
    this.getCategoryList()
  },
  methods: {
    // 加载数据
    getData (data) {
      const that = this
      fetchPrograms(data).then((res) => {
        if (res.code == '1') {
          that.tableData = res.results
          // 获取分类data
          that.tableData.map((item) => {
            var tags = []
            if (item.sndCategory) {
              tags.push(item.category, item.sndCategory)
            } else if (item.category) {
              tags.push(item.category)
            }
            item.tagsList = tags
          })
          this.paginationOption = {
            ...this.paginationOption,
            'current-page': this.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    // 查询
    search () {
      this.currentPageHandler(1)
      this.isShow = false
    },
    resetHandle (formName) {
      this.$refs[formName].resetFields()
      this.isShow = false
    },
    // 获取选中数据
    selectionChange (selection) {
      this.multipleSelection = selection
    },
    sizeChangeHandler (val) {
      this.isShow = false
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getData(this.searchParams)
    },
    currentPageHandler (val) {
      this.isShow = false
      this.searchParams.offset = val
      let params = { ...this.searchParams }
      if (this.searchParams.auditState == -1) {
        params = {
          ...this.searchParams,
          auditState: '',
          pushFlag: -1
        }
      }
      this.getData(params)
    },
    // 获取分类下拉框内容
    getCategoryList: function () {
      var that = this
      that.categoryList = []
      const data = {
        limit: 25,
        dataKey: 'category',
        dataFlag: 0
      }
      fetchDictionarys(data).then((res) => {
        if (res.code != 1) {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          return false
        }
        var dataItem = res.results
        var len = dataItem.length
        var arr = []
        for (var i = 0; i < len; i++) {
          arr.push({ value: dataItem[i].dataValue, label: dataItem[i].dataValue })
        }
        that.categoryList = arr
      })
    },
    // 视频上传
    goUploadVideo () {
      this.$router.push({ path: '/uploadFile' })
    },
    // 批量加入专辑
    batchJoinAlbum () {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'info',
          message: '请先勾选数据'
        })
        return false
      }
      const newArr = this.multipleSelection.filter(function (value) {
        return value.programSetId || !value.category
      })
      if (this.multipleSelection.length > 0 && newArr.length > 0) {
        this.$message({
          type: 'info',
          message: '已加入专辑和未完成编目的节目，不能加入专辑，请重新选择'
        })
      } else {
        this.$router.push({ path: '/batchJoinAlbum', query: { multipleSelection: this.multipleSelection } })
      }
    },
    // 导入媒资数据
    goBatchImport () {
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.batchImportDataDialog.open()
      })
    },
    dbClick (row, $event) {
      this.dialogData = {
        data: row,
        project: 'ugc'
      }
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.isShow = true
      })
    },
    goDetailInfo (row) {
      this.dialogData = row
      this.imgUrl = this.dialogData.video.videoImgPaths[0].imgPath
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.detailDialog.open()
      })
    },
    goEdit (id) {
      this.$router.push({
        path: '/newGroup',
        query: {
          programId: id.id
        }
      })
    },
    del (row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetchProgramsDelete({
          id: row.id,
          updateBy: this.$store.state.router.updateBy
        }).then(() => {
          this.getData(this.searchParams)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 查看未通过原因
    checkReson (row) {
      checkReason({
        type: 0,
        resourceId: row.id
      }).then((res) => {
        this.$alert(res.result, '原因', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      })
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '标题：',
          placeholder: '请输入标题查询',
          clearable: true,
          labelWidth: '60px',
          col: [3, 3, 3]
        },
        {
          prop: 'category',
          label: '分类：',
          type: 'select',
          filterable: true,
          clearable: true,
          options: this.categoryList
        },
        {
          prop: 'auditState',
          type: 'select',
          label: '作品状态：',
          filterable: true,
          clearable: true,
          options: addData.publishState
        },
        { prop: 'search', type: 'slot', label: '' }
      ]
    }
  }
}
</script>
<style lang="less">
  .reson {
    color: #1700FF;
    padding-left: 20px;
    cursor: pointer;
  }
  .auditStyle {
    .orange {
      color: orange;
    }
    .red {
      color: red;
    }
    .green{
      color: #6EB360;
    }
  }
</style>
